import { defineMessages } from "react-intl";
import { useIntl, FormattedMessage } from "react-intl";

import Button from "@atlaskit/button";
import AkEmptyState from "@atlaskit/empty-state";

export const EmptyStatePage = () => {
    const intl = useIntl();

    return (
        <AkEmptyState
            header={intl.formatMessage(EmptyStatePage.messages.header)}
            description={
                <div>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: intl.formatMessage(
                                EmptyStatePage.messages.introBodyDescription
                            )
                        }}
                    />
                    <p
                        dangerouslySetInnerHTML={{
                            __html: intl.formatMessage(
                                EmptyStatePage.messages.introBody
                            )
                        }}
                    />
                </div>
            }
            primaryAction={
                <Button appearance="primary" href="/">
                    <FormattedMessage
                        {...EmptyStatePage.messages.administrationButton}
                    />
                </Button>
            }
            imageUrl={""}
            maxImageWidth={348}
            maxImageHeight={190}
            width="wide"
            testId="rovo-all-orgs-enabled-state"
        />
    );
};

EmptyStatePage.messages = defineMessages({
    administrationButton: {
        id: "Wac.Signup.PostOrder.Org.Setup.empty.page.administrationButton",
        defaultMessage: "Go to Atlassian Administration",
        description:
            "Redirect to Admin Hub when all orgs have product(s) enabled"
    },
    header: {
        id: "Wac.Signup.PostOrder.Org.Setup.empty.page.header",
        defaultMessage:
            "There are no eligible organizations for provisioning your order. ",
        description: "Organization Setup landing page header"
    },
    introBodyDescription: {
        id: "Wac.Signup.PostOrder.Org.Setup.empty.page.introBodyDescription",
        defaultMessage:
            "It's possible that all your organizations already have the product(s), or you might need to sign in with a different account that has permissions to provision. ",
        description: "Organization Setup landing page header Description"
    },
    introBody: {
        id: "Wac.Signup.PostOrder.Org.Setup.empty.page.introBody",
        defaultMessage:
            "View your existing organizations in Atlassian Administration.",
        description:
            "Organization Setup header for screen when all orgs are enabled"
    }
});
